import flagUs from "assets/images/flags/20/us.svg";
import flagspain from "assets/images/flags/20/es.svg";
import flaggermany from "assets/images/flags/20/de.svg";
import flagfrench from "assets/images/flags/20/fr.svg";
import flagjapan from "assets/images/flags/20/jp.svg";
import flagchina from "assets/images/flags/20/china.svg";
import flagitaly from "assets/images/flags/20/it.svg";
import flagrussia from "assets/images/flags/20/ru.svg";
import flagarabic from "assets/images/flags/20/ae.svg";
import flagiran from "assets/images/flags/ir.svg";


const languages = {
  fa: {
    label: "Persian",
    flag: flagiran,
  },
  sp: {
    label: "Española",
    flag: flagspain,
  },
  gr: {
    label: "Deutsche",
    flag: flaggermany,
  },
  it: {
    label: "Italiana",
    flag: flagitaly,
  },
  rs: {
    label: "русский",
    flag: flagrussia,
  },
  en: {
    label: "English",
    flag: flagUs,
  },
  cn: {
    label: "中国人",
    flag: flagchina,
  },
  fr: {
    label: "français",
    flag: flagfrench,
  },
  ar: {
    label: "Arabic",
    flag: flagarabic,
  },
  jp: {
    label: "日本語",
    flag: flagjapan,
  },
}

export default languages
